if (!customElements.get('product-size-comparison')) {
  customElements.define(
    'product-size-comparison',
    class ProductSizeComparison extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;

        this.trigger ||= this.querySelector('[data-comparison-open]');
        this.dialog = this.querySelector('[data-comparison-dialog]');
        this.closeButton = this.querySelector('[data-comparison-close]');

        if (!this.trigger || !this.dialog || !this.closeButton) return;

        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.trigger.addEventListener('click', () => this.open(), { signal });
        this.closeButton.addEventListener('click', () => this.dialog.close(), { signal });
        this.dialog.addEventListener('click', (event) => this.handleBackdropClick(event), { signal });
        this.dialog.addEventListener('close', () => this.handleClose(), { signal });

        this.sectionRoot = this.closest('[id^="shopify-section-"]');
        this.placeTrigger();
        if (this.sectionRoot) {
          this.positionObserver = new MutationObserver(() => this.placeTrigger());
          this.positionObserver.observe(this.sectionRoot, { childList: true, subtree: true });
        }
      }

      disconnectedCallback() {
        this.positionObserver?.disconnect();
        // The dialog stays here; only the trigger belongs to the plugin layout.
        if (this.trigger?.parentElement !== this) this.trigger?.remove();
        this.abortController?.abort();
        this.abortController = undefined;
        document.documentElement.classList.remove('product-comparison-open');
      }

      placeTrigger() {
        const group = this.sectionRoot?.querySelector(
          '#king-linked-options-section .lv-option-group[data-option-index="0"]'
        );
        this.toggleAttribute('data-comparison-relocated', Boolean(group));
        if (group) {
          if (this.trigger.parentElement !== group) group.append(this.trigger);
        } else if (this.trigger.parentElement !== this) {
          this.insertBefore(this.trigger, this.dialog);
        }
      }

      open() {
        if (this.dialog.open) return;

        this.previouslyFocusedElement = document.activeElement;
        document.documentElement.classList.add('product-comparison-open');
        this.dialog.showModal();
        this.closeButton.focus();
      }

      handleBackdropClick(event) {
        if (event.target === this.dialog) this.dialog.close();
      }

      handleClose() {
        document.documentElement.classList.remove('product-comparison-open');
        if (this.previouslyFocusedElement?.isConnected) this.previouslyFocusedElement.focus();
      }
    }
  );
}
